import {AlwaysRowInnerSection} from '../InnerSection'
import {Container} from './components/Container'
import {ReactComponent as Logo} from '../../assets/logo.svg'
import {LanguageSelector} from './components/LanguageSelector'

export const Header = () => (
  <Container>
    <AlwaysRowInnerSection>
      <Logo />
      <LanguageSelector />
    </AlwaysRowInnerSection>
  </Container>
)
